const isActive = (path: string): boolean =>
	window.location.pathname.startsWith(path);

export { isActive };
